import { render, staticRenderFns } from "./ProductSkeleton.vue?vue&type=template&id=64806f9e&scoped=true&"
import script from "./ProductSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ProductSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSkeleton.vue?vue&type=style&index=0&id=64806f9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64806f9e",
  null
  
)

export default component.exports